import React, { useState, useEffect, useCallback } from 'react';
import { Button, Card, Spinner, Alert, Modal } from 'react-bootstrap';
import api from './api';
import KlinikDiyetisyenFormu from './KlinikDiyetisyenFormu';

function KlinikDiyetisyenler({ theme }) {
  const [diyetisyenler, setDiyetisyenler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  
  const [showModal, setShowModal] = useState(false);
  const [duzenlenenDiyetisyen, setDuzenlenenDiyetisyen] = useState(null);

  const diyetisyenleriGetir = useCallback(async () => {
    try {
      const response = await api.get('/klinik/diyetisyenler');
      setDiyetisyenler(response.data);
    } catch (err) {
      setError("Diyetisyenler yüklenirken bir hata oluştu.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { diyetisyenleriGetir(); }, [diyetisyenleriGetir]);

  const handleFormSubmit = async (formData) => {
    const isUpdating = !!duzenlenenDiyetisyen;
    // GÜNCELLENDİ: Artık URL'ye diyetisyen ID'sini de ekliyoruz
    const url = isUpdating ? `/klinik/diyetisyenler/${duzenlenenDiyetisyen.id}` : '/klinik/diyetisyenler';
    const method = isUpdating ? 'put' : 'post';

    // GÜNCELLENDİ: Düzenleme sırasında şifre boşsa, veriden çıkar
    if (isUpdating && !formData.sifre) {
      delete formData.sifre;
    }

    try {
      await api[method](url, formData);
      setShowModal(false);
      diyetisyenleriGetir();
    } catch (err) {
      alert(`Hata: ${err.response?.data?.mesaj || 'İşlem başarısız oldu'}`);
    }
  };

  // YENİ: Diyetisyen silme fonksiyonu
  const handleSil = async (diyetisyenId) => {
    if (!window.confirm("Bu diyetisyeni silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.")) {
      return;
    }
    try {
      await api.delete(`/klinik/diyetisyenler/${diyetisyenId}`);
      diyetisyenleriGetir(); // Silme sonrası listeyi yenile
    } catch (err) {
      alert(`Hata: ${err.response?.data?.mesaj || 'Silme işlemi başarısız'}`);
    }
  };

  const handleModalOpen = (diyetisyen = null) => {
    setDuzenlenenDiyetisyen(diyetisyen);
    setShowModal(true);
  };
  
  const handleModalClose = () => {
    setDuzenlenenDiyetisyen(null);
    setShowModal(false);
  };

  if (loading) return <Spinner animation="border" variant={theme === 'dark' ? 'light' : 'dark'} />;
  if (error) return <Alert variant="danger">{error}</Alert>;

  return (
    <>
      <Card className="glass-card text-white">
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <Card.Title as="h2">Klinik Diyetisyenleri</Card.Title>
            <Button variant="light" onClick={() => handleModalOpen()}>+ Yeni Diyetisyen Ekle</Button>
          </div>
          <div style={{ overflowX: 'auto' }}>
            <table className="data-table">
              <thead>
                <tr>
                  <th>Kullanıcı Adı</th>
                  <th>E-posta</th>
                  <th>Telefon</th>
                  <th className="text-end">İşlemler</th>
                </tr>
              </thead>
              <tbody>
                {diyetisyenler.map(diyetisyen => (
                  <tr key={diyetisyen.id}>
                    <td data-label="Kullanıcı Adı">{diyetisyen.kullanici_adi}</td>
                    <td data-label="E-posta">{diyetisyen.eposta}</td>
                    <td data-label="Telefon">{diyetisyen.telefon || '-'}</td>
                    <td data-label="İşlemler" className="text-end">
                      {/* GÜNCELLENDİ: Butonlar artık aktif ve fonksiyonlara bağlı */}
                      <Button variant="warning" size="sm" onClick={() => handleModalOpen(diyetisyen)}>Düzenle</Button>
                      <Button variant="danger" size="sm" className="ms-2" onClick={() => handleSil(diyetisyen.id)}>Sil</Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card.Body>
      </Card>

      <Modal show={showModal} onHide={handleModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {duzenlenenDiyetisyen ? 'Diyetisyen Düzenle' : 'Yeni Diyetisyen Ekle'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <KlinikDiyetisyenFormu 
            mevcutDiyetisyen={duzenlenenDiyetisyen}
            onFormSubmit={handleFormSubmit}
            onIptal={handleModalClose}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
export default KlinikDiyetisyenler;